/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-12-02 12:51:24                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-02 12:56:32                               *
 *****************************************************************************/

export enum CustomerType {
  PROSPECT = "PROSPECT",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE"
}